import React from "react"
import InputTextControl from "./InputTextControl";
import InputHiddenControl from "./InputHiddenControl";
import InputTextarea from "./InputTextarea";
import InputDateControl from "./InputDateControl";
import InputEmailControl from "./InputEmailControl";
import InputColorPicker from "./InputColorPicker";
import AudienceSegmentCreator from "src/mtska-frontend-modules/modules/AudienceSegment/wizards/AudienceSegmentCreator";
import InputFileControl from "./InputFileControl";
import InputDropzoneControl from "./InputDropzoneControl";
import InputNumberControl from "./InputNumberControl";
import InputSelect from "./InputSelect";
import InputRadio from "./InputRadio";
import InputCheckbox from "./InputCheckbox";
import InputSwitch from "./InputSwitch";
import InputList from "./InputList"
import CampaignSummary from "./CampaignSummary"
import SectionTitle from "./SectionTitle";
import SectionParagraph from "./SectionParagraph";
import SectionMessageBlock from "./SectionMessageBlock";
import ViewEmploymentDetail from "./ViewEmploymentDetail";
import ViewCostList from "./ViewCostList";
import ViewContractDetail from "./ViewContractDetail";
import WidgetMakeModelSetup from "./WidgetMakeModelSetup";
import WidgetAuthorizedsOfDriver from './WidgetAuthorizedsOfDriver';
import WidgetServicesOfDriver from './WidgetServicesOfDriver';
import WidgetCostCar from './WidgetCostCar';
import WidgetCostPerson from './WidgetCostPerson';
import WidgetCostContract from './WidgetCostContract';
import WidgetCostService from './WidgetCostService';
import WidgetCostSupplier from './WidgetCostSupplier';
import WidgetCalendarBooking from './WidgetCalendarBooking';
import WidgetDocumentPreview from './WidgetDocumentPreview';
import WidgetFringeBenefitSimilar from './WidgetFringeBenefitSimilar'
import WidgetSpeechReader from './WidgetSpeechReader'
import InputListCar from "./InputListCar";
import InputListPool from "./InputListPool";
import InputListService from "./InputListService";
import InputListPerson from "./InputListPerson";
import InputListContract from "./InputListContract";
import InputListEmployment from "./InputListEmployment";
import InputListDocument from "./InputListDocument";
import InputListLead from "./InputListLead";
import InputListTrace from "./InputListTrace";
import { InputDrawerButton } from ".";
import InputListFringeBenefitCar from "./InputListFringeBenefitCar";
import InputAutocompleteControl from "./InputAutocompleteControl";
import InputAutocomplete from "./InputAutocomplete";
import InputChip from "./InputChip";
import InputBudgetChecker from "./WidgetBudgetChecker"
import WidgetBudgetChecker from "./WidgetBudgetChecker";
import WidgetActivityEditor from "./WidgetActivityEditor";
import InputListAudienceLead from "./InputListAudienceLead";
import InputListAudienceSegment from "./InputListAudienceSegment";
import InputListCampaignLead from "./InputListCampaignLead";
import InputListCampaignReassignment from "./InputListCampaignReassignment";
import InputListCampaignActivityOutcome from "./InputListCampaignActivityOutcome";
import InputIconSelector from "./InputIconSelector";
import InputListRuleset from "./InputListRuleset";
import InputListRule from "./InputListRule";
import InputRuleEditorControl from "./InputRuleEditorControl";
import InputRulesEditorControl from "./InputRulesEditorControl";
import WidgetPreviewExcelData from "./WidgetPreviewExcelData";
import WidgetMapping from "./WidgetMapping";
import JSONPretty from 'react-json-pretty'

const Input = (props) => {

    if (props.type === 'drawerButton') return <InputDrawerButton {...props} />
    if (props.type === 'text') return <InputTextControl {...props} />
    if (props.type === 'file') return <InputFileControl {...props} />
    if (props.type === 'dropzone') return <InputDropzoneControl {...props} />
    if (props.type === 'hidden') return <InputHiddenControl {...props} />
    if (props.type === 'textarea') return <InputTextarea {...props} />
    if (props.type === 'number') return <InputNumberControl {...props} />
    if (props.type === 'date' || props.type === 'datetime') return <InputDateControl {...props} />
    if (props.type === 'email') return <InputEmailControl {...props} />
    if (props.type === 'colorpicker') return <InputColorPicker {...props} />
    if (props.type === 'iconSelector') return <InputIconSelector {...props} />
    if (props.type === 'audienceSegmentationRule') return <AudienceSegmentCreator {...props} />

    
    if (props.type === 'select') return <InputSelect {...props} />
    if (props.type === 'radio') return <InputRadio {...props} />
    if (props.type === 'checkbox') return <InputCheckbox {...props} />
    if (props.type === 'switch') return <InputSwitch {...props} />

    if (props.type === 'sectiontitle') return <SectionTitle {...props} />
    if (props.type === 'sectionparagraph') return <SectionParagraph {...props} />
    if (props.type === 'sectionmessageblock') return <SectionMessageBlock {...props} />

    if (props.type === 'list') return <InputList {...props} />
    if (props.type === 'carlist') return <InputListCar {...props} />
    if (props.type === 'poollist') return <InputListPool {...props} />
    if (props.type === 'personlist') return <InputListPerson {...props} />
    if (props.type === 'employmentlist') return <InputListEmployment {...props} />
    if (props.type === 'servicelist') return <InputListService {...props} />
    if (props.type === 'contractlist') return <InputListContract {...props} />
    if (props.type === 'documentlist') return <InputListDocument {...props} />
    if (props.type === 'leadlist') return <InputListLead {...props} />
    if (props.type === 'segmentlist') return <InputListAudienceSegment {...props} />
    if (props.type === 'audienceleadlist') return <InputListAudienceLead {...props} />
    if (props.type === 'campaignleadlist') return <InputListCampaignLead {...props} /> 
    if (props.type === 'campaignreassignmentlist') return <InputListCampaignReassignment {...props} /> 
    if (props.type === 'campaignactivityoutcomelist') return <InputListCampaignActivityOutcome {...props} /> 
    if (props.type === 'tracelist') return <InputListTrace {...props} />
    if (props.type === 'fringebenefitcarlist') return <InputListFringeBenefitCar {...props} />
    if (props.type === 'partnershipRulesetList') return <InputListRuleset {...props} />
    if (props.type === 'partnershipRuleList') return <InputListRule {...props} />    
    if (props.type === 'ruleEditor') return <InputRuleEditorControl {...props} /> 
    if (props.type === 'rulesEditor') return <InputRulesEditorControl {...props} /> 

    if (props.type === 'costlist') return <ViewCostList {...props} />
    if (props.type === 'employmentdetail') return <ViewEmploymentDetail {...props} />
    if (props.type === 'contractdetail') return <ViewContractDetail {...props} />
    if (props.type === 'makeModelSetup') return <WidgetMakeModelSetup {...props} />
    if (props.type === 'calendarBooking') return <WidgetCalendarBooking {...props} />
    if (props.type === 'campaignsummary') return <CampaignSummary {...props} />

    if (props.type === 'autocomplete') return <InputAutocompleteControl {...props} />
    if (props.type === 'chip') return <InputChip {...props} />

    switch (props.type) {
        case 'previewWidget':
            return <WidgetDocumentPreview {...props} />
        case 'authorizedsWidget':
            return <WidgetAuthorizedsOfDriver {...props} />
        case 'costCarWidget':
            return <WidgetCostCar {...props} />
        case 'costPersonWidget':
            return <WidgetCostPerson {...props} />
        case 'costContractWidget':
            return <WidgetCostContract {...props} />
        case 'costServiceWidget':
            return <WidgetCostService {...props} />
        case 'costSupplierWidget':
            return <WidgetCostSupplier {...props} />
        case 'serviceWidget':
            return <WidgetServicesOfDriver {...props} />
        case 'fringeBenefitSimilarWidget':
            return <WidgetFringeBenefitSimilar {...props} />
        case 'budgetChecker':
            return <WidgetBudgetChecker {...props} />
        case 'activityeditor':
            return <WidgetActivityEditor {...props} />
        case 'speechreader':
            return <WidgetSpeechReader {...props} />
        case 'previewexceldata':
            return <WidgetPreviewExcelData {...props} />
        case 'mapping':
            return <WidgetMapping {...props} />
        default:
            return null;

    }
    return <InputTextControl {...props} />

};

export default Input
